// components/Hero2.jsx
import React, { useEffect, useRef, useState } from "react";
import "./Hero2.css";

import AssistantDirectionRoundedIcon from "@mui/icons-material/AssistantDirectionRounded";
import SelfImprovementRoundedIcon from "@mui/icons-material/SelfImprovementRounded";
import Diversity3RoundedIcon from "@mui/icons-material/Diversity3Rounded";

function Hero2() {
  const [inView, setInView] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setInView(true);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="how"
      ref={sectionRef}
      className={`guided-hero2-section ${inView ? "is-visible" : ""}`}
    >
      <div className="guided-hero2-inner">
        {/* Left: text, like hero slide 2 */}
        <div className="guided-hero2-text">
          {/* <p className="guided-hero2-kicker">Guided with Care</p> */}
          <h2 className="guided-hero2-title">Your Pilgrimage, Guided with Care</h2>

          <p className="guided-hero2-body">
            Hajj and Umrah are profoundly sacred journeys, but language barriers,
            gigantic crowds, and unfamiliar surroundings can make them
            overwhelming. Tawaf walks beside you with gentle, voice-led guidance
            in your language; keeping you informed, oriented, and supported, so
            your journey is filled with worship, not worry.
          </p>

          <p className="guided-hero2-caption">
            Tawaf supports you in three simple, human ways:
          </p>
        </div>

        {/* Right: three small “pillar” cards (same spirit as hero slide 2) */}
        <div className="guided-hero2-pillars">
          <article className="guided-hero2-pillar guided-hero2-pillar--1">
            <div className="guided-hero2-pillar-icon">
              <AssistantDirectionRoundedIcon fontSize="small" />
            </div>
            <h3>Clarity</h3>
            <p>
              Get clear step-by-step guidance from planning your travel to
              performing every ritual, so you always know what to do next.
            </p>
          </article>

          <article className="guided-hero2-pillar guided-hero2-pillar--2">
            <div className="guided-hero2-pillar-icon guided-hero2-pillar-icon-soft">
              <SelfImprovementRoundedIcon fontSize="small" />
            </div>
            <h3>Confidence</h3>
            <p>
              Feel calm and in control; less worried about getting lost or doing
              things wrong, and more focused on worship.
            </p>
          </article>

          <article className="guided-hero2-pillar guided-hero2-pillar--3">
            <div className="guided-hero2-pillar-icon guided-hero2-pillar-icon-strong">
              <Diversity3RoundedIcon fontSize="small" />
            </div>
            <h3>Connection</h3>
            <p>
              Stay informed, oriented, and connected to your group, loved ones,
              and key locations, no matter how crowded the journey gets.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
}

export default Hero2;
